import { useEffect, useState } from 'react';
import {
  fetchLibreChatMessages,
  LibreChatMessage,
} from '../../../../api/services/chat-service';

export const useLibreChatMessages = (
  conversationId: string | null,
): { messages: LibreChatMessage[]; loading: boolean; error: string | null } => {
  const [messages, setMessages] = useState<LibreChatMessage[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    if (!conversationId) {
      setMessages([]);
      return;
    }
    setLoading(true);
    setError(null);
    fetchLibreChatMessages(conversationId, controller.signal)
      .then(setMessages)
      .catch(() => setError('Failed to load messages'))
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, [conversationId]);

  return { messages, loading, error };
};
